// extracted by mini-css-extract-plugin
export default {"loadingContainer":"style_loadingContainer__AkUMu","logoLoading":"style_logoLoading__oO9FL","pulsate-bck":"style_pulsate-bck__FicHC"};